// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/var/jenkins_home/workspace/tunnel-miot-ui.01-01.miot-front-mgmt.deploy/src/models/device';
import model_2 from '/var/jenkins_home/workspace/tunnel-miot-ui.01-01.miot-front-mgmt.deploy/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'device', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
